export enum SelectedStrategy {
  Admin = 'Admin',
  AdminAssociation = 'AdminAssociation',
}
